function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M84.375 44.9125V15.625C84.375 14.3818 83.8811 13.1895 83.0021 12.3104C82.123 11.4314 80.9307 10.9375 79.6875 10.9375H7.8125C6.5693 10.9375 5.37701 11.4314 4.49794 12.3104C3.61886 13.1895 3.125 14.3818 3.125 15.625V62.5C3.125 63.7432 3.61886 64.9355 4.49794 65.8146C5.37701 66.6936 6.5693 67.1875 7.8125 67.1875H50.0797C50.3507 71.2624 51.6825 75.1956 53.9428 78.597C56.2031 81.9983 59.3134 84.7496 62.9652 86.5779C66.6169 88.4062 70.6833 89.248 74.7608 89.0197C78.8383 88.7914 82.7853 87.501 86.2102 85.2765C89.635 83.0521 92.4188 79.9708 94.2853 76.3384C96.1518 72.706 97.0362 68.6487 96.8507 64.569C96.6653 60.4894 95.4164 56.5291 93.2279 53.081C91.0395 49.633 87.9876 46.817 84.375 44.9125ZM7.8125 14.0625H79.6875C80.1019 14.0625 80.4993 14.2271 80.7924 14.5201C81.0854 14.8132 81.25 15.2106 81.25 15.625V19.3297L47.1312 35.7078C46.0765 36.2161 44.9208 36.48 43.75 36.48C42.5792 36.48 41.4235 36.2161 40.3688 35.7078L6.25 19.3297V15.625C6.25 15.2106 6.41462 14.8132 6.70765 14.5201C7.00067 14.2271 7.3981 14.0625 7.8125 14.0625ZM6.25 62.5V22.7953L39.0172 38.5234C40.4931 39.2361 42.111 39.6063 43.75 39.6063C45.389 39.6063 47.0069 39.2361 48.4828 38.5234L81.25 22.7953V43.5547C77.8434 42.3346 74.1998 41.9232 70.6069 42.3528C67.014 42.7824 63.5701 44.0413 60.5472 46.0302C57.5243 48.0191 55.0051 50.6834 53.1885 53.8128C51.3719 56.9423 50.3076 60.4512 50.0797 64.0625H7.8125C7.3981 64.0625 7.00067 63.8979 6.70765 63.6049C6.41462 63.3118 6.25 62.9144 6.25 62.5ZM73.4375 85.9375C69.4201 85.9375 65.4929 84.7462 62.1525 82.5142C58.8121 80.2823 56.2086 77.1099 54.6712 73.3983C53.1338 69.6866 52.7315 65.6025 53.5153 61.6622C54.2991 57.722 56.2336 54.1026 59.0744 51.2619C61.9151 48.4211 65.5345 46.4866 69.4747 45.7028C73.415 44.919 77.4991 45.3213 81.2108 46.8587C84.9224 48.3961 88.0948 50.9996 90.3267 54.34C92.5587 57.6804 93.75 61.6076 93.75 65.625C93.7438 71.0103 91.6017 76.1733 87.7938 79.9813C83.9858 83.7892 78.8228 85.9313 73.4375 85.9375Z",
  fill: "url(#paint200_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.625 73.4375H18.75V76.5625H15.625V73.4375Z",
  fill: "url(#paint201_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.875 73.4375H37.5V76.5625H21.875V73.4375Z",
  fill: "url(#paint202_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 56.25V53.125H9.375V56.25C9.375 57.4932 9.86886 58.6855 10.7479 59.5646C11.627 60.4436 12.8193 60.9375 14.0625 60.9375H17.1875V57.8125H14.0625C13.6481 57.8125 13.2507 57.6479 12.9576 57.3549C12.6646 57.0618 12.5 56.6644 12.5 56.25Z",
  fill: "url(#paint203_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9.375 46.875H12.5V50H9.375V46.875Z",
  fill: "url(#paint204_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M71.875 48.4375H75V51.5625H71.875V48.4375Z",
  fill: "url(#paint205_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M61.2722 54.1204L63.4819 51.9107L65.6916 54.1204L63.4819 56.3301L61.2722 54.1204Z",
  fill: "url(#paint206_linear)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M57.8125 62.5H60.9375V65.625H57.8125V62.5Z",
  fill: "url(#paint207_linear)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M81.1577 54.1223L83.3674 51.9126L85.5771 54.1223L83.3674 56.332L81.1577 54.1223Z",
  fill: "url(#paint208_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M85.9375 62.5H89.0625V65.625H85.9375V62.5Z",
  fill: "url(#paint209_linear)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M82.8125 64.0625C82.8143 62.4514 82.4009 60.8671 81.6122 59.4623C80.8235 58.0575 79.686 56.8797 78.3096 56.0424C76.9332 55.2052 75.3642 54.7367 73.7541 54.6823C72.1439 54.6279 70.5469 54.9894 69.1171 55.7318C67.6873 56.4743 66.473 57.5727 65.5912 58.921C64.7095 60.2694 64.1901 61.8222 64.0832 63.4297C63.9762 65.0372 64.2854 66.6452 64.9807 68.0985C65.6761 69.5517 66.7343 70.8013 68.0531 71.7266C68.1132 71.7727 68.1706 71.8223 68.225 71.875H65.625V75H68.75V78.125C68.75 78.5394 68.9146 78.9368 69.2076 79.2299C69.5007 79.5229 69.8981 79.6875 70.3125 79.6875H76.5625C76.9769 79.6875 77.3743 79.5229 77.6673 79.2299C77.9604 78.9368 78.125 78.5394 78.125 78.125V75H81.25V71.875H78.6672C78.7062 71.8422 78.725 71.7953 78.7687 71.7656C80.0151 70.904 81.034 69.7531 81.7383 68.4115C82.4425 67.07 82.8111 65.5777 82.8125 64.0625ZM75 76.5625H71.875V75H75V76.5625ZM71.7437 71.875C71.4606 70.7723 70.7851 69.8107 69.8437 69.1703C68.7542 68.4062 67.937 67.3143 67.5111 66.0535C67.0852 64.7927 67.0728 63.4289 67.4758 62.1606C67.8788 60.8923 68.6761 59.7857 69.7517 59.002C70.8272 58.2183 72.1248 57.7984 73.4556 57.8033C74.7864 57.8083 76.0808 58.2379 77.1505 59.0295C78.2202 59.8212 79.0093 60.9337 79.4028 62.2049C79.7964 63.4762 79.7739 64.8399 79.3386 66.0975C78.9033 67.3551 78.078 68.4409 76.9828 69.1969C76.0593 69.8338 75.4003 70.7862 75.1297 71.875H71.7437Z",
  fill: "url(#paint210_linear)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M77.2609 65.4609L75.864 62.6641L73.4375 63.8781L71.0109 62.6641L69.614 65.4609L71.8749 66.5906V68.75H75V66.5906L77.2609 65.4609Z",
  fill: "url(#paint211_linear)"
});

var _ref14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint200_linear",
  x1: 5.66749,
  y1: 99.3336,
  x2: 81.704,
  y2: 0.411473,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint201_linear",
  x1: 15.7097,
  y1: 76.9736,
  x2: 18.8471,
  y2: 73.5725,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint202_linear",
  x1: 22.2987,
  y1: 76.9736,
  x2: 23.4219,
  y2: 70.8856,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint203_linear",
  x1: 9.58687,
  y1: 61.9653,
  x2: 17.4303,
  y2: 53.4625,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint204_linear",
  x1: 9.45975,
  y1: 50.4111,
  x2: 12.5971,
  y2: 47.01,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint205_linear",
  x1: 71.9597,
  y1: 51.9736,
  x2: 75.0971,
  y2: 48.5725,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint206_linear",
  x1: 63.8326,
  y1: 56.5609,
  x2: 63.6461,
  y2: 51.9374,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint207_linear",
  x1: 57.8972,
  y1: 66.0361,
  x2: 61.0346,
  y2: 62.635,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint208_linear",
  x1: 83.7181,
  y1: 56.5628,
  x2: 83.5316,
  y2: 51.9394,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint209_linear",
  x1: 86.0222,
  y1: 66.0361,
  x2: 89.1596,
  y2: 62.635,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint210_linear",
  x1: 64.571,
  y1: 82.9779,
  x2: 89.2302,
  y2: 62.9371,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint211_linear",
  x1: 69.8214,
  y1: 69.5507,
  x2: 75.6698,
  y2: 61.5844,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})));

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.067c161b.svg";
export { ForwardRef as ReactComponent };